/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { compose, mapProps, pure, setPropTypes } from 'recompose'
import docShape from 'shapes/Document'
import docNavShape from 'shapes/DocumentNavigation'
import barPlotNav from 'shapes/PhotoNavigation'
import processBarPlotNav from 'utils/processQueries/barPlotNavigation'
import processDocument from 'utils/processQueries/document'
import processDocNav from 'utils/processQueries/documentNavigation'

export const Document = compose(
  pure,
  mapProps(({ data: { doc, docs, barPlots }, ...props }) => {
    return {
      ...props,
      barPlotNavigation: processBarPlotNav(barPlots),
      document: processDocument(doc),
      documentNavigation: processDocNav(docs),
    }
  }),
  setPropTypes({
    barPlots: barPlotNav.list,
    className: PropTypes.string,
    document: docShape.single,
    documentNavigation: docNavShape.list
  })
)

export default Document
